// Comprehensive job titles list organized by categories and levels

export const JOB_TITLES_BY_CATEGORY = {
  'Software Development': [
    // Entry Level
    'Junior Software Developer', 'Junior Frontend Developer', 'Junior Backend Developer',
    'Junior Full Stack Developer', 'Associate Software Engineer', 'Trainee Software Developer',
    'Graduate Software Engineer', 'Intern - Software Development',
    
    // Mid Level
    'Software Developer', 'Frontend Developer', 'Backend Developer', 'Full Stack Developer',
    'Software Engineer', 'Web Developer', 'Application Developer', 'Mobile App Developer',
    'React Developer', 'Angular Developer', 'Node.js Developer', 'Python Developer',
    'Java Developer', '.NET Developer', 'PHP Developer', 'Ruby Developer',
    
    // Senior Level
    'Senior Software Developer', 'Senior Frontend Developer', 'Senior Backend Developer',
    'Senior Full Stack Developer', 'Senior Software Engineer', 'Principal Engineer',
    'Staff Engineer', 'Distinguished Engineer',
    
    // Lead Level
    'Lead Software Developer', 'Tech Lead', 'Engineering Manager', 'Development Manager',
    'Director of Engineering', 'VP Engineering', 'CTO', 'Chief Technology Officer'
  ],

  'Data & Analytics': [
    // Entry Level
    'Junior Data Analyst', 'Junior Data Scientist', 'Data Analyst Intern', 'Associate Data Analyst',
    'Junior Business Analyst', 'Analytics Associate',
    
    // Mid Level
    'Data Analyst', 'Data Scientist', 'Business Analyst', 'Business Intelligence Analyst',
    'Data Engineer', 'Analytics Engineer', 'Machine Learning Engineer', 'AI Engineer',
    'Big Data Engineer', 'ETL Developer', 'Data Warehouse Developer',
    
    // Senior Level
    'Senior Data Analyst', 'Senior Data Scientist', 'Senior Data Engineer',
    'Senior Business Analyst', 'Senior ML Engineer', 'Principal Data Scientist',
    
    // Lead Level
    'Lead Data Scientist', 'Lead Data Engineer', 'Data Science Manager', 'Head of Data',
    'Director of Analytics', 'VP Data & Analytics', 'Chief Data Officer', 'CDO'
  ],

  'Design & UX': [
    // Entry Level
    'Junior UI Designer', 'Junior UX Designer', 'Associate Designer', 'Design Intern',
    'Junior Graphic Designer', 'Junior Product Designer',
    
    // Mid Level
    'UI Designer', 'UX Designer', 'UI/UX Designer', 'Product Designer', 'Graphic Designer',
    'Visual Designer', 'Interaction Designer', 'UX Researcher', 'Motion Designer',
    'Brand Designer', 'Illustrator', 'Web Designer',
    
    // Senior Level
    'Senior UI Designer', 'Senior UX Designer', 'Senior Product Designer',
    'Principal Designer', 'Staff Designer',
    
    // Lead Level
    'Lead Designer', 'Design Manager', 'Head of Design', 'Design Director',
    'VP Design', 'Chief Design Officer', 'CDO'
  ],

  'Product Management': [
    // Entry Level
    'Associate Product Manager', 'Junior Product Manager', 'Product Management Intern',
    
    // Mid Level
    'Product Manager', 'Technical Product Manager', 'Product Owner', 'Scrum Master',
    'Product Analyst', 'Product Marketing Manager',
    
    // Senior Level
    'Senior Product Manager', 'Principal Product Manager', 'Group Product Manager',
    
    // Lead Level
    'Lead Product Manager', 'Director of Product', 'VP Product', 'Head of Product',
    'Chief Product Officer', 'CPO'
  ],

  'DevOps & Cloud': [
    // Entry Level
    'Junior DevOps Engineer', 'Associate DevOps Engineer', 'Cloud Engineer Trainee',
    
    // Mid Level
    'DevOps Engineer', 'Site Reliability Engineer', 'SRE', 'Cloud Engineer',
    'Platform Engineer', 'Infrastructure Engineer', 'Build Engineer', 'Release Engineer',
    'AWS Engineer', 'Azure Engineer', 'GCP Engineer', 'Kubernetes Engineer',
    
    // Senior Level
    'Senior DevOps Engineer', 'Senior SRE', 'Senior Cloud Engineer',
    'Principal DevOps Engineer', 'Staff SRE',
    
    // Lead Level
    'Lead DevOps Engineer', 'DevOps Manager', 'Head of DevOps', 'Director of Infrastructure',
    'VP Engineering Infrastructure'
  ],

  'Quality Assurance & Testing': [
    // Entry Level
    'Junior QA Engineer', 'Junior Test Engineer', 'QA Intern', 'Associate QA Analyst',
    
    // Mid Level
    'QA Engineer', 'Test Engineer', 'Quality Analyst', 'Software Tester',
    'Automation Test Engineer', 'SDET', 'Performance Test Engineer', 'Security Test Engineer',
    'QA Analyst', 'Test Automation Engineer',
    
    // Senior Level
    'Senior QA Engineer', 'Senior Test Engineer', 'Senior SDET', 'Principal QA Engineer',
    
    // Lead Level
    'Lead QA Engineer', 'QA Manager', 'Test Manager', 'Head of QA', 'Director of Quality'
  ],

  'Sales & Business Development': [
    // Entry Level
    'Sales Trainee', 'Junior Sales Executive', 'Sales Associate', 'BDE Trainee',
    'Inside Sales Representative', 'Sales Development Representative', 'SDR',
    
    // Mid Level
    'Sales Executive', 'Business Development Executive', 'BDE', 'Account Executive',
    'Sales Manager', 'Business Development Manager', 'BDM', 'Key Account Manager',
    'Enterprise Sales Executive', 'Channel Sales Manager',
    
    // Senior Level
    'Senior Sales Manager', 'Senior BDM', 'Principal Account Manager',
    'Regional Sales Manager', 'Area Sales Manager',
    
    // Lead Level
    'Sales Director', 'VP Sales', 'Head of Sales', 'Chief Sales Officer', 'CSO',
    'Director of Business Development', 'VP Business Development'
  ],

  'Marketing & Digital Marketing': [
    // Entry Level
    'Marketing Intern', 'Junior Marketing Executive', 'Marketing Associate',
    'Digital Marketing Trainee', 'Social Media Intern',
    
    // Mid Level
    'Marketing Executive', 'Digital Marketing Executive', 'Marketing Manager',
    'Digital Marketing Manager', 'Content Marketing Manager', 'SEO Specialist',
    'SEM Specialist', 'Social Media Manager', 'Performance Marketing Manager',
    'Brand Manager', 'Growth Marketing Manager', 'Email Marketing Manager',
    
    // Senior Level
    'Senior Marketing Manager', 'Senior Digital Marketing Manager',
    'Principal Marketing Manager',
    
    // Lead Level
    'Marketing Director', 'Head of Marketing', 'VP Marketing',
    'Chief Marketing Officer', 'CMO', 'Director of Digital Marketing'
  ],

  'HR & Recruitment': [
    // Entry Level
    'HR Intern', 'Junior HR Executive', 'HR Associate', 'Recruitment Trainee',
    'Junior Recruiter', 'Talent Acquisition Associate',
    
    // Mid Level
    'HR Executive', 'HR Manager', 'Recruiter', 'Senior Recruiter',
    'Talent Acquisition Specialist', 'HR Business Partner', 'HRBP',
    'HR Generalist', 'Compensation & Benefits Manager', 'L&D Manager',
    
    // Senior Level
    'Senior HR Manager', 'Senior TA Manager', 'Principal HR Manager',
    
    // Lead Level
    'HR Director', 'Head of HR', 'VP HR', 'Chief Human Resources Officer', 'CHRO',
    'Director of Talent Acquisition', 'Head of Recruitment'
  ],

  'Finance & Accounting': [
    // Entry Level
    'Junior Accountant', 'Accounts Executive', 'Finance Trainee', 'Audit Trainee',
    
    // Mid Level
    'Accountant', 'Senior Accountant', 'Finance Manager', 'Financial Analyst',
    'Accounts Manager', 'Finance Executive', 'Tax Consultant', 'Auditor',
    'Treasury Manager', 'Financial Controller',
    
    // Senior Level
    'Senior Finance Manager', 'Senior Financial Analyst', 'Principal Accountant',
    
    // Lead Level
    'Finance Director', 'Head of Finance', 'VP Finance', 'CFO',
    'Chief Financial Officer', 'Director of Accounting'
  ],

  'Operations & Supply Chain': [
    // Entry Level
    'Operations Trainee', 'Junior Operations Executive', 'Operations Associate',
    
    // Mid Level
    'Operations Manager', 'Operations Executive', 'Supply Chain Manager',
    'Logistics Manager', 'Warehouse Manager', 'Procurement Manager',
    'Inventory Manager', 'Process Manager', 'Operations Analyst',
    
    // Senior Level
    'Senior Operations Manager', 'Senior Supply Chain Manager',
    
    // Lead Level
    'Operations Director', 'Head of Operations', 'VP Operations', 'COO',
    'Chief Operating Officer', 'Director of Supply Chain'
  ],

  'Customer Support & Success': [
    // Entry Level
    'Customer Support Executive', 'Customer Service Representative', 'Support Associate',
    'Help Desk Associate', 'Customer Service Intern',
    
    // Mid Level
    'Customer Support Manager', 'Customer Success Manager', 'Technical Support Engineer',
    'Customer Service Manager', 'Client Support Manager', 'Account Manager',
    
    // Senior Level
    'Senior Customer Success Manager', 'Senior Support Manager',
    
    // Lead Level
    'Head of Customer Support', 'Director of Customer Success', 'VP Customer Success'
  ],

  'Content & Communication': [
    // Entry Level
    'Content Writer Intern', 'Junior Content Writer', 'Copywriter Trainee',
    
    // Mid Level
    'Content Writer', 'Senior Content Writer', 'Content Manager', 'Copywriter',
    'Technical Writer', 'Content Strategist', 'Editor', 'Communications Manager',
    'Public Relations Manager', 'PR Manager',
    
    // Senior Level
    'Senior Content Manager', 'Principal Writer', 'Content Marketing Lead',
    
    // Lead Level
    'Head of Content', 'Director of Content', 'VP Communications'
  ],

  'Administration & Management': [
    // Entry Level
    'Administrative Assistant', 'Office Assistant', 'Executive Assistant Trainee',
    
    // Mid Level
    'Executive Assistant', 'Office Manager', 'Administrative Manager',
    'Facilities Manager', 'Business Manager', 'General Manager',
    
    // Senior Level
    'Senior Manager', 'Senior General Manager',
    
    // Lead Level
    'Director', 'Senior Director', 'VP', 'President', 'CEO', 'Chief Executive Officer',
    'Managing Director', 'Founder', 'Co-Founder'
  ],

  'Hospitality & Tourism': [
    // Entry Level
    'Hotel Receptionist', 'Front Desk Agent', 'Bellboy', 'Room Attendant', 'Housekeeping Staff',
    'Restaurant Server', 'Waiter', 'Waitress', 'Bartender Trainee', 'Kitchen Helper',
    
    // Mid Level
    'Front Office Manager', 'Guest Relations Manager', 'Concierge', 'Restaurant Manager',
    'Bartender', 'Head Chef', 'Sous Chef', 'Banquet Manager', 'Catering Manager',
    'Hotel Manager', 'Resort Manager', 'Hospitality Manager', 'Food & Beverage Manager',
    'Housekeeping Manager', 'Event Coordinator', 'Wedding Planner',
    
    // Senior Level
    'Senior Hotel Manager', 'Executive Chef', 'Director of Operations',
    
    // Lead Level
    'General Manager - Hospitality', 'Director of Hospitality', 'VP Hospitality',
    'Regional Manager - Hotels', 'Area Manager - Hotels'
  ],

  'Healthcare & Medical': [
    // Entry Level
    'Medical Assistant', 'Nursing Assistant', 'Health Care Assistant', 'Pharmacy Assistant',
    'Lab Technician Trainee', 'Medical Receptionist', 'Patient Care Coordinator',
    
    // Mid Level
    'Registered Nurse', 'Staff Nurse', 'ICU Nurse', 'OT Nurse', 'Emergency Nurse',
    'Lab Technician', 'Medical Lab Technician', 'Radiology Technician', 'X-Ray Technician',
    'Pharmacist', 'Clinical Pharmacist', 'Physiotherapist', 'Occupational Therapist',
    'Dental Hygienist', 'Medical Coder', 'Medical Transcriptionist', 'Health Information Manager',
    
    // Senior Level
    'Senior Nurse', 'Nurse Manager', 'Senior Pharmacist', 'Senior Physiotherapist',
    'Chief Medical Officer', 'Medical Director',
    
    // Lead Level
    'Director of Nursing', 'Head of Pharmacy', 'Hospital Administrator',
    'Healthcare Administrator', 'VP Healthcare Operations'
  ],

  'Education & Training': [
    // Entry Level
    'Teaching Assistant', 'Junior Teacher', 'Trainee Teacher', 'Assistant Professor',
    'Lab Instructor', 'Tutor', 'Private Tutor',
    
    // Mid Level
    'Teacher', 'Primary School Teacher', 'High School Teacher', 'Subject Teacher',
    'Mathematics Teacher', 'Science Teacher', 'English Teacher', 'Computer Teacher',
    'Lecturer', 'Professor', 'Corporate Trainer', 'Soft Skills Trainer',
    'Technical Trainer', 'Training Manager', 'Instructional Designer',
    
    // Senior Level
    'Senior Teacher', 'Senior Professor', 'Senior Lecturer', 'Senior Trainer',
    'Head of Department', 'Academic Coordinator',
    
    // Lead Level
    'Principal', 'Vice Principal', 'Dean', 'Director of Education',
    'Training Head', 'VP Learning & Development'
  ],

  'Retail & Sales': [
    // Entry Level
    'Retail Sales Associate', 'Shop Assistant', 'Cashier', 'Store Clerk',
    'Sales Assistant', 'Merchandiser Trainee',
    
    // Mid Level
    'Store Manager', 'Retail Manager', 'Branch Manager', 'Area Supervisor',
    'Visual Merchandiser', 'Merchandising Manager', 'Category Manager',
    'Retail Operations Manager', 'Store Supervisor', 'Floor Manager',
    
    // Senior Level
    'Senior Store Manager', 'Regional Store Manager', 'Senior Retail Manager',
    
    // Lead Level
    'Retail Director', 'Director of Retail Operations', 'VP Retail',
    'Head of Retail', 'Regional Manager - Retail'
  ],

  'Manufacturing & Production': [
    // Entry Level
    'Production Worker', 'Assembly Line Worker', 'Machine Operator', 'Factory Worker',
    'Quality Control Inspector', 'Production Helper', 'Warehouse Associate',
    
    // Mid Level
    'Production Supervisor', 'Production Manager', 'Manufacturing Engineer',
    'Quality Control Manager', 'Quality Assurance Manager', 'Plant Manager',
    'Production Planner', 'Process Engineer', 'Maintenance Engineer',
    'Industrial Engineer', 'Production Coordinator',
    
    // Senior Level
    'Senior Production Manager', 'Senior Manufacturing Engineer',
    'Senior Quality Manager', 'Plant Head',
    
    // Lead Level
    'Director of Manufacturing', 'VP Manufacturing', 'Head of Production',
    'Director of Operations - Manufacturing'
  ],

  'Automotive & Mechanics': [
    // Entry Level
    'Junior Mechanic', 'Mechanic Helper', 'Auto Technician Trainee', 'Service Advisor Trainee',
    'Auto Electrician Helper', 'Bodywork Helper',
    
    // Mid Level
    'Automotive Technician', 'Auto Mechanic', 'Senior Mechanic', 'Diesel Mechanic',
    'Auto Electrician', 'AC Mechanic', 'Transmission Specialist', 'Engine Specialist',
    'Bodywork Technician', 'Paint Technician', 'Service Advisor', 'Service Manager',
    'Workshop Manager', 'Workshop Supervisor', 'Automotive Engineer',
    
    // Senior Level
    'Senior Automotive Technician', 'Master Technician', 'Senior Service Manager',
    'Workshop Manager', 'Service Center Manager',
    
    // Lead Level
    'Service Director', 'Director of Service Operations', 'Regional Service Manager'
  ],

  'Construction & Real Estate': [
    // Entry Level
    'Construction Worker', 'Helper', 'Mason Helper', 'Carpenter Helper', 'Electrician Helper',
    'Plumber Helper', 'Site Helper',
    
    // Mid Level
    'Mason', 'Carpenter', 'Electrician', 'Plumber', 'Welder', 'Painter',
    'Site Supervisor', 'Site Engineer', 'Civil Engineer', 'Structural Engineer',
    'Project Manager - Construction', 'Quantity Surveyor', 'Site Manager',
    'Real Estate Agent', 'Property Manager', 'Real Estate Consultant',
    
    // Senior Level
    'Senior Civil Engineer', 'Senior Project Manager', 'Senior Site Manager',
    'Senior Real Estate Manager',
    
    // Lead Level
    'Construction Manager', 'Director of Construction', 'VP Real Estate',
    'Head of Real Estate', 'Regional Construction Manager'
  ],

  'Security & Safety': [
    // Entry Level
    'Security Guard', 'Security Officer', 'Watchman', 'Safety Officer Trainee',
    
    // Mid Level
    'Security Supervisor', 'Security Manager', 'Safety Officer', 'Safety Manager',
    'Fire Safety Officer', 'Industrial Safety Officer', 'EHS Manager',
    'Security Operations Manager', 'Loss Prevention Manager',
    
    // Senior Level
    'Senior Security Manager', 'Senior Safety Manager', 'Chief Security Officer',
    
    // Lead Level
    'Director of Security', 'Head of Security', 'VP Security & Safety'
  ],

  'Transportation & Logistics': [
    // Entry Level
    'Delivery Boy', 'Delivery Executive', 'Driver', 'Truck Driver', 'Delivery Driver',
    'Courier', 'Logistics Associate',
    
    // Mid Level
    'Logistics Coordinator', 'Transport Manager', 'Fleet Manager', 'Dispatch Manager',
    'Logistics Manager', 'Supply Chain Coordinator', 'Warehouse Supervisor',
    'Distribution Manager', 'Shipping Manager',
    
    // Senior Level
    'Senior Logistics Manager', 'Senior Transport Manager', 'Senior Fleet Manager',
    
    // Lead Level
    'Director of Logistics', 'VP Logistics', 'Head of Transportation',
    'Director of Supply Chain'
  ],

  'Legal & Compliance': [
    // Entry Level
    'Legal Assistant', 'Paralegal', 'Legal Associate', 'Compliance Trainee',
    
    // Mid Level
    'Legal Advisor', 'Corporate Lawyer', 'Legal Counsel', 'Compliance Officer',
    'Compliance Manager', 'Legal Manager', 'Contract Manager',
    
    // Senior Level
    'Senior Legal Counsel', 'Senior Compliance Manager', 'Principal Legal Advisor',
    
    // Lead Level
    'General Counsel', 'Chief Legal Officer', 'CLO', 'Head of Legal',
    'Director of Compliance', 'VP Legal'
  ],

  'Media & Entertainment': [
    // Entry Level
    'Junior Video Editor', 'Production Assistant', 'Camera Assistant', 'Junior Animator',
    
    // Mid Level
    'Video Editor', 'Videographer', 'Photographer', 'Camera Operator',
    'Animator', '3D Artist', 'VFX Artist', 'Sound Engineer', 'Audio Engineer',
    'Film Editor', 'Producer', 'Director', 'Content Producer',
    
    // Senior Level
    'Senior Video Editor', 'Senior Producer', 'Senior Director',
    
    // Lead Level
    'Creative Director', 'Director of Production', 'VP Content Production'
  ],

  'Beauty & Wellness': [
    // Entry Level
    'Beauty Therapist Trainee', 'Salon Assistant', 'Spa Trainee',
    
    // Mid Level
    'Hair Stylist', 'Beautician', 'Makeup Artist', 'Nail Technician',
    'Beauty Therapist', 'Spa Therapist', 'Massage Therapist', 'Salon Manager',
    'Spa Manager', 'Wellness Coach', 'Fitness Trainer', 'Yoga Instructor',
    
    // Senior Level
    'Senior Hair Stylist', 'Senior Makeup Artist', 'Senior Spa Manager',
    
    // Lead Level
    'Salon Owner', 'Spa Director', 'Director of Wellness'
  ],

  'Agriculture & Farming': [
    // Entry Level
    'Farm Worker', 'Agricultural Helper', 'Farm Hand',
    
    // Mid Level
    'Farm Manager', 'Agricultural Officer', 'Agronomist', 'Horticulturist',
    'Farm Supervisor', 'Agricultural Engineer', 'Plantation Manager',
    
    // Senior Level
    'Senior Agronomist', 'Senior Farm Manager',
    
    // Lead Level
    'Director of Agriculture', 'Head of Farming Operations'
  ]
};

// Flatten all job titles
export const ALL_JOB_TITLES = [...new Set(Object.values(JOB_TITLES_BY_CATEGORY).flat())].sort();

// Popular job titles
export const POPULAR_JOB_TITLES = [
  'Software Developer', 'Frontend Developer', 'Backend Developer', 'Full Stack Developer',
  'Data Analyst', 'Data Scientist', 'Business Analyst', 'Product Manager',
  'UI/UX Designer', 'Graphic Designer', 'DevOps Engineer', 'QA Engineer',
  'Sales Executive', 'Business Development Executive', 'Marketing Manager',
  'HR Manager', 'Accountant', 'Content Writer', 'Hotel Manager', 'Restaurant Manager',
  'Nurse', 'Teacher', 'Retail Manager', 'Auto Mechanic', 'Civil Engineer',
  'Security Guard', 'Delivery Executive', 'Warehouse Manager', 'Beautician',
  'Fitness Trainer', 'Chef', 'Receptionist', 'Customer Support Executive'
];

// Search job titles
export const searchJobTitles = (query, limit = 30) => {
  if (!query) return POPULAR_JOB_TITLES;
  
  const lowerQuery = query.toLowerCase().trim();
  
  // Filter titles that include the query
  const results = ALL_JOB_TITLES.filter(title => 
    title.toLowerCase().includes(lowerQuery)
  );

  // Sort by relevance
  results.sort((a, b) => {
    const aLower = a.toLowerCase();
    const bLower = b.toLowerCase();
    
    // Exact match
    if (aLower === lowerQuery) return -1;
    if (bLower === lowerQuery) return 1;
    
    // Starts with query
    if (aLower.startsWith(lowerQuery) && !bLower.startsWith(lowerQuery)) return -1;
    if (bLower.startsWith(lowerQuery) && !aLower.startsWith(lowerQuery)) return 1;
    
    // Alphabetical
    return a.localeCompare(b);
  });
  
  return results.slice(0, limit);
};
